import { Injectable, OnInit, Type } from '@angular/core'
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar'
import { NavigationEnd, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { filter, Observable, take } from 'rxjs'
import { GbYesNoSnackBarComponent } from '../components/gb-yes-no-snack-bar/gb-yes-no-snack-bar.component'

@Injectable({
  providedIn: 'root',
})
export class GbNotificationService {
  private notificationDuration = 5000
  private snackBarComponentRef?: MatSnackBarRef<any>

  constructor(private snackBar: MatSnackBar, private translateService: TranslateService, private router: Router) {}

  message(message: string, action = '', duration?: number): MatSnackBarRef<TextOnlySnackBar> {
    const panelClass = 'default-notification'
    message = this.translateService.instant(message)
    if (action) {
      action = this.translateService.instant(action)
    }

    return this.snackBarOpen(message, action, panelClass, duration)
  }

  error(message: string, action = '', translateParams?: {} | undefined): void {
    const panelClass = 'error-notification'
    message = this.translateService.instant(message, translateParams)
    if (action) {
      action = this.translateService.instant(action)
    }

    this.snackBarOpen(message, action, panelClass)
  }

  success(message: string, action = ''): void {
    const panelClass = 'success-notification'
    message = this.translateService.instant(message)
    if (action) {
      action = this.translateService.instant(action)
    }

    this.snackBarOpen(message, action, panelClass)
  }

  snackBarOpen(
    message: string,
    action: string,
    panelClass?: string,
    duration?: number,
  ): MatSnackBarRef<TextOnlySnackBar> {
    return this.snackBar.open(message, action, {
      duration: duration || this.notificationDuration,
      panelClass: panelClass,
    })
  }

  snackBarComponentOpen<T>(component: Type<T>): void {
    this.snackBarComponentRef = this.snackBar.openFromComponent(component, {
      duration: 0,
    })
  }

  isSnackBarComponentOpen(): boolean {
    return !!this.snackBarComponentRef
  }

  dismissSnackBarComponent(): void {
    this.snackBarComponentRef?.dismiss()
    this.snackBarComponentRef = undefined
  }

  yesNo(message: string, panelClass?: string): Observable<boolean> {
    const snackBarRef: MatSnackBarRef<GbYesNoSnackBarComponent> = this.snackBar.openFromComponent(
      GbYesNoSnackBarComponent,
      {
        duration: 0,
        panelClass: panelClass,
        data: { message: this.translateService.instant(message) },
      },
    )

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
      )
      .subscribe(() => {
        snackBarRef.dismiss()
      })

    return snackBarRef.instance.getActionObservable()
  }
}
